import Big from 'big.js';

export const toFixed = (num: number, precision = 0): number => {
    return parseFloat(num.toFixed(precision));
};

export const toBigFixed = (input: string | number | undefined | null, decimalPlaces = 2): string | undefined => {
    if (
        input === null ||
        input == undefined ||
        (typeof input === 'number' && isNaN(input)) ||
        (typeof input === 'string' && isNaN(Number(input)))
    ) {
        return undefined;
    }
    return new Big(input).toFixed(decimalPlaces);
};
